module.exports = __webpack_public_path__ + "img/earth.c2be0ee6.png";